var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from 'mobx';
import { BaseDialogState } from '@/app/UIComponents/BaseDialog';
import { APPEvent } from '@/events/AppEvents';
import { Apphandler } from '@/ipc/MainAppHandler';
export class IncomingCallDialogState {
    constructor() {
        this.open = false;
        this.email = "";
        this.name = "";
        this.nameerror = "";
        this.letrid = "";
        this.emailerror = "";
        this.enableInvite = false;
        this.sending = false;
        this.sendingresult = "";
        this.sendingresultcolro = "green";
        this.baseDialogState = new BaseDialogState();
        this.audio = undefined;
        this.audioref = null;
        makeObservable(this);
        this.baseDialogState.setHeaderLabel("Incoming Call");
        this.baseDialogState.setOkLabel("Acccept");
        this.baseDialogState.setCancelLabel("Decline");
        this.baseDialogState.onClose = () => this.declineCall();
        APPEvent.addSubscriberForIncomingCall((res) => {
            this.setLetrId(res.letrid);
            const namestr = res.letrdetail.memberDetails.map((mem) => {
                return mem.name;
            }).join(",");
            this.setName(namestr);
            this.setOpen(true);
            // setTimeout(() => this.startAudio(), 100);
        });
        APPEvent.addSubscriberForDeclineCallRes((res) => {
            console.log('declined ' + res);
            if (res !== undefined && res) {
                this.setOpen(false);
            }
        });
    }
    declineCall() {
        this.stopAudio();
        const req = {
            letrid: this.letrid,
            incoming: true
        };
        Apphandler.sendMessage("declineletrcall", req);
    }
    setOpen(open) {
        this.open = open;
        this.baseDialogState.setOpen(open);
    }
    setName(name) {
        this.name = name;
    }
    setLetrId(id) {
        this.letrid = id;
    }
    startAudio() {
        var _a;
        (_a = this.audioref) === null || _a === void 0 ? void 0 : _a.play();
        if (this.audioref !== null) {
            this.audioref.loop = true;
        }
    }
    stopAudio() {
        var _a;
        (_a = this.audioref) === null || _a === void 0 ? void 0 : _a.pause();
        if (this.audioref !== null) {
            this.audioref.currentTime = 0;
            this.audioref.loop = false;
        }
    }
    reset() {
        this.setName("");
        this.setLetrId("");
        this.audioref = null;
        this.setOpen(false);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], IncomingCallDialogState.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], IncomingCallDialogState.prototype, "email", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], IncomingCallDialogState.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], IncomingCallDialogState.prototype, "nameerror", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], IncomingCallDialogState.prototype, "letrid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], IncomingCallDialogState.prototype, "emailerror", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], IncomingCallDialogState.prototype, "enableInvite", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], IncomingCallDialogState.prototype, "sending", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], IncomingCallDialogState.prototype, "sendingresult", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], IncomingCallDialogState.prototype, "sendingresultcolro", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], IncomingCallDialogState.prototype, "setOpen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], IncomingCallDialogState.prototype, "setName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], IncomingCallDialogState.prototype, "setLetrId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], IncomingCallDialogState.prototype, "startAudio", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], IncomingCallDialogState.prototype, "stopAudio", null);
